import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';

import {
    userSearchResultCrmIdsDataSelector,
    userSearchResultCrmIdsResultSelector,
} from '../../slices/user-search-result-crm-ids.slice';

type Props = {
    userId: number,
};

export const SalesforceIdCell = ({userId}: Props) => {
    const {isLoading, loadingError} = useSelector(userSearchResultCrmIdsDataSelector);
    const result = useSelector(userSearchResultCrmIdsResultSelector);

    const salesforceId = useMemo(
        () => result?.data[userId]?.SFDCId,
        [result, userId],
    );

    if (isLoading || loadingError || !salesforceId) {
        return null;
    }

    return (
        <EllipsisTextHint title={salesforceId}>{salesforceId}</EllipsisTextHint>
    );
};
